import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import Table from "../../../../../common/components/table";
import PageLoader from "../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import { accountWebPageCards } from "../../../../../redux/web-page-cards/action";
import { accountWebPages } from "../../../../../redux/web-pages/action";
import { selectAccountWebPagesListItems } from "../../../../../redux/web-pages/selector";
import { selectAccountWebPageCardsListItems } from "../../../../../redux/web-page-cards/selector";



const DBNAccountWebPageInfoComponent = () => {

	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [storedItems, setStoredItems] = useState<any>({});

  useEffect(() => {
      const storedValue = localStorage.getItem('storageKey');
      if (storedValue) {
          try {
              const parsedValue = JSON.parse(storedValue);
              setStoredItems(parsedValue.items || []);
          } catch (error) {
              console.error("Error parsing JSON from localStorage:", error);
          }
      } else {
          console.log("No stored value found");
      }
  }, []);
    const accountWebPageItems = useSelector(selectAccountWebPagesListItems)
    const accountWebPageCardsItems = useSelector(selectAccountWebPageCardsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          {
            field: 'WebsiteName',
            headerName: 'WebsiteName',
            sortable: true,
            filter: true,
          },
          {
            field: 'PageName',
            headerName: 'PageName',
            sortable: true,
            filter: true,
          },
          {
            field: 'LayoutName',
            headerName: 'LayoutName',
            sortable: true,
            filter: true,
          },  {
            field: 'CardName',
            headerName: 'CardName',
            sortable: true,
            filter: true,
          },
        ]);
      }

   
      const fetchDBNAccountWebPage=async ()=>{
        await dispatch(accountWebPages.resetAction({ actionType: 'list' }));
        const listData = await dispatch(accountWebPages.list({
					url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/web-pages/accounts/fetch`,
					entity: 'accountWebPages',
					jsonData: {
						
              "Context": {},
              "Records": [
                  {
                    GlobalOrgRegistryId: storedItems?.Id
                  }
              ],
              "Pagination": {
                  "PageNumber": 1,
                  "PageSize": 50,
                  "SortField": "Id",
                  "SortOrder": "desc"
              }
          
					}
				}));
			
        if (listData?.items?.length > 0 && listData?.items[0]?.AccountWebPageId) {
          const firstWebsiteId = listData.items[0]?.AccountWebPageId;
          const TenantId =listData.items[0]?.TenantId;
          await dispatch(accountWebPageCards.resetAction({ actionType: 'list' }));
          await dispatch(accountWebPageCards.list({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/fetch`,
            entity: 'websiteCards',
            jsonData: {
              "Records": [
                {
                  "Context": {},
                  "Message": {
                    Id:firstWebsiteId,
                    TenantId:TenantId,
                  }
                }
              ]
            },
					}));
    
    }  
  }  
      // const handleEdit=(data: any)=>{
      //  navigate(`tenantId/${selectedOrgRegistry?.TenantId}/webpage/${data.Id}`)
      // }

      const handleSearch = async (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        fetchDBNAccountWebPage()
      }
      
	useEffect(() => {
    if(storedItems?.Id){
        createColumnDefs()
        fetchDBNAccountWebPage()
    }
	}, [pageData,pageSize,storedItems])

  
	return (
    <>
    {accountWebPageCardsItems?.isLoading ?  <PageLoader />: 
		<Table columnData={columnDefs}
    onSearch={handleSearch}rowData={accountWebPageCardsItems?.items?.items} setPageData={setPageData}
    paginationData={accountWebPageCardsItems?.result?.pagination}
    setPageSize={setPageSize}headingName="DBN Account Web Page"/>
     
  }
  </> 
	);
};

export default DBNAccountWebPageInfoComponent;


